import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { app } from "../firebase";
import { resolveUserRole } from "../utils/authRoles";

const defaultRedirectByRole = {
  admin: "/dashboard",
  client: "/my-orders",
};

function RoleRoute({ allowedRoles = [], children }) {
  const [loading, setLoading] = useState(true);
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    role: null,
  });

  useEffect(() => {
    const auth = getAuth(app);
    const db = getFirestore(app);

    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setAuthState({ isAuthenticated: false, role: null });
        setLoading(false);
        return;
      }

      try {
        const { role } = await resolveUserRole(db, user.uid);
        setAuthState({ isAuthenticated: true, role });
      } catch (error) {
        console.error("Error resolving role:", error);
        setAuthState({ isAuthenticated: true, role: null });
      } finally {
        setLoading(false);
      }
    });

    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(authState.role)) {
    const fallback = defaultRedirectByRole[authState.role] || "/login";
    return <Navigate to={fallback} replace />;
  }

  return children;
}

export default RoleRoute;
